/*
 * MIT License
 * Copyright (c) 2020 Excellens
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import {Merge} from "./Base";

/**
 * Assert the element tag-name is equal to the element-name.
 *
 * @param {Object}  element
 * @param {string}  elementName
 * @returns {boolean}
 */
function assertType(element, elementName) {
    if (element.tagName.toUpperCase() === elementName.toUpperCase()) {
        return true;
    }

    throw 'ERR_ELEMENT_NAME';
}

export function Element(document, elementName, element) {
    const self = (function (document, elementName, element) {
        element = !!element
            ? element
            : document.createElement(elementName);

        assertType(element, elementName);

        return element;
    }(document, elementName, element));

    return Merge(this, self);
}
